/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmEmbeddingsEmbed } from "../../funcs/llmEmbeddingsEmbed.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.EmbedRequest$inboundSchema,
};

export const tool$llmEmbeddingsEmbed: ToolDefinition<typeof args> = {
  name: "llm-embeddings-embed",
  description: `Create text embeddings

Generates vector embeddings for single or multiple text inputs. Returns floating-point vectors along with token usage statistics.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmEmbeddingsEmbed(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
